import { motion } from "motion/react";
import { createElement } from "react";
import { TbCheck } from "react-icons/tb";

import { FormSteps, formSteps } from "./CreateCustomPassengerDialog";

function CreateCustomUserStepper({
    currentStep,
    handleCurrentStep,
}: {
    handleCurrentStep: (step: FormSteps) => void;
    currentStep: FormSteps;
}) {
    return (
        <div className="  bg-white">
            <div className="relative pt-2 pb-4 sm:pb-8">
                <div className="absolute top-6 left-0 right-0 bg-gray-200 h-2 bg-muted dark:bg-slate-700 rounded-full">
                    <motion.div
                        className="h-full bg-primary rounded-full"
                        initial={{ width: 0 }}
                        animate={{ width: `${((currentStep + 1) / formSteps.length) * 100}%` }}
                        transition={{ duration: 0.8, ease: "easeInOut" }}
                    />
                </div>

                <div className="relative z-10 flex justify-around">
                    {formSteps.map((step) => {
                        const index = formSteps.indexOf(step);
                        const isCompleted = index < currentStep;
                        const isCurrent = index === currentStep;

                        return (
                            <div
                                onClick={() => handleCurrentStep(step.step)}
                                key={index}
                                className={
                                    "flex flex-col items-center w-24 cursor-pointer" +
                                    ((index === currentStep && "cursor-default") || "")
                                }
                                role="button"
                                tabIndex={0}
                            >
                                <div
                                    className={
                                        "w-10 h-10 rounded-full flex items-center  justify-center border-2 bg-white dark:bg-slate-900 transition-all mb-4 " +
                                        ((isCompleted && "bg-primary border-primary text-primary-foreground") || "") +
                                        ((isCurrent && "border-primary text-primary") || "")
                                    }
                                >
                                    {isCompleted ? <TbCheck className="h-5 w-5" /> : createElement(step.icon)}
                                </div>
                                <span
                                    className={
                                        "text-sm font-semibold hidden sm:block text-center absolute top-12 whitespace-nowrap"
                                    }
                                >
                                    {step.title}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default CreateCustomUserStepper;
